import { html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { FontSizes, FontWeights } from '../../../types/common/types';
import { ButtonFill, LinkColor, LinkType, Target } from '../types';
import { ifDefined } from 'lit/directives/if-defined.js';

export class GzLinkWebComponent extends LitElement {
  @property({ type: String, attribute: true, reflect: true })
  iconSize: FontSizes = FontSizes.BODY;

  @property({ type: String, attribute: true, reflect: true })
  fontSize: FontSizes;

  @property({ type: String, attribute: true, reflect: true })
  fontWeight: FontWeights;

  @property({ type: Boolean, reflect: true })
  showIcon = false;

  @property({ type: Boolean, attribute: true, reflect: true })
  disabled = false;

  @property({ type: String, attribute: true, reflect: true })
  type: LinkType = LinkType.QUIET;

  @property({ type: String, attribute: true, reflect: true })
  color: LinkColor = LinkColor.PRIMARY;

  @property({ type: String, attribute: true, reflect: true })
  fill: ButtonFill;

  @property({ type: String, attribute: true, reflect: true })
  href = '';

  @property({ type: String, attribute: true, reflect: true })
  target: Target = Target.BLANK;

  @property({ type: String, attribute: true, reflect: true })
  download: string;

  private expandLinkIcon = 'ds-icon-expand';

  @property()
  callback?: null | EventListenerOrEventListenerObject;

  static get styles() {
    return styles;
  }

  render() {
    return html`
      <div @click="${this.callback}" class="wrapper" ?disabled="${this.disabled}" part="container">
        ${this.linkRenderer()}
      </div>
    `;
  }

  private linkRenderer() {
    if (this.href) {
      return html` <a href="${this.href}" target="${this.target}" .download="${ifDefined(this.download)}">
        ${this.renderContent()}
      </a>`;
    }
    return this.renderContent();
  }

  private renderContent() {
    return html`<slot></slot> ${this.showIcon ? html`<div class="icon-element ${this.expandLinkIcon}"></div>` : ''}`;
  }
}
